import script from "./CrearEmpresaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CrearEmpresaModal.vue?vue&type=script&setup=true&lang=js"

import "./CrearEmpresaModal.vue?vue&type=style&index=0&id=19735da8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19735da8"]])

export default __exports__